import OTPFormFooter from './OTPFormFooter';
import StarFormFooter from './StarFormFooter';
import TiFormFooter from './TiFormFooter';
import generateRender from 'shared/utils/generateRender';

const FormFooter = generateRender({
  default: OTPFormFooter,
  ti: TiFormFooter,
  star: StarFormFooter,
});

export default FormFooter;
